import { gql, TypedDocumentNode } from '@apollo/client'

import { AlertDTO } from '../types/alertDTO'

export const ALERT_FRAGMENT: TypedDocumentNode<AlertDTO> = gql`
  fragment AlertFragment on Alert {
    name
    description
  }
`
